import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rabbinat',
  templateUrl: './rabbinat.component.html',
  styleUrls: ['./../app.component.css']
})
export class RabbinatComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
